import { render, staticRenderFns } from "./login.html?vue&type=template&id=54f444e4&scoped=true&"
import script from "./login.js?vue&type=script&lang=js&"
export * from "./login.js?vue&type=script&lang=js&"
import style0 from "./login.scss?vue&type=style&index=0&id=54f444e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f444e4",
  null
  
)

export default component.exports